import { ActionIcon, Badge } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales';
import { MAIL_CATEGORY_COLORS, MAIL_CATEGORY_LABELS, type MailCategory } from 'modules/Mails/types';
import { useUpdateMail } from 'shared/hooks/use-update-mail';
import { CategoryDot } from './CategoryDot';

type CategoryBadgeProps = {
  category: MailCategory;
  onRemove: () => void;
};

export const CategoryBadge = ({ category, onRemove }: CategoryBadgeProps) => {
  const { t } = useTranslation();
  const { isUpdateMailLoading } = useUpdateMail();

  const color = MAIL_CATEGORY_COLORS[category];

  return (
    <Badge
      variant="light"
      size="sm"
      color={color}
      leftSection={<CategoryDot color={color} />}
      rightSection={
        <ActionIcon
          size="xs"
          variant="transparent"
          color={color}
          disabled={isUpdateMailLoading}
          onClick={onRemove}
          aria-label={t(i18nKeys.EXTERNAL_MAIL.DETAIL_NEXT.REMOVE_CATEGORY, {
            name: t(MAIL_CATEGORY_LABELS[category]),
          })}
        >
          <IconX size={10} stroke={2.5} />
        </ActionIcon>
      }
    >
      {t(MAIL_CATEGORY_LABELS[category])}
    </Badge>
  );
};
